export const isResendAvailable = (authenticator) => {
  const type = authenticator && authenticator.type;
  return ['push', 'sms', 'email'].includes(type);
}
